<template>
	<div 
		class="lob-button"
		:class="[
			{ small: small },
			theme
		]"
	>
		<font-awesome-icon 
			v-if="left && icon"
			class="lob-button__icon left"
			:icon="icon" 
		/>

		{{ text }}

		<font-awesome-icon 
			v-if="right && icon"
			class="lob-button__icon right"
			:icon="icon" 
		/>
	</div>
</template>

<script>
	export default {
		props: {
			text: {
				type: String,
				required: true
			},
			icon: {
				type: String, 
				default: ''
			},
			small: {
				type: Boolean,
				default: false
			},
			left: {
				type: Boolean,
				default: false
			},
			right: {
				type: Boolean, 
				default: false
			},
			theme: {
				type: String, 
				default: ''
			}
		}	
	};
</script>

<style lang="scss" scoped>
	.lob-button {
		padding: 0.7em 1em 0.7em;
		display: inline-block;
		border-radius: 20px;
		transition: 0.5s;
		background-size: 200% auto;
		cursor: pointer;
		box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

		&.small {
			padding: 0.25em 1.25em 0.35em;
			font-size: 0.9em;
		}
		font-weight: 600;

		background-image: linear-gradient(to right, #FDE74C 0%, #FFFFFF 51%, #FDE74C 100%);
		color: $_copy-alt;
		margin: 0 0.5em;

		&__icon {
			&.right {
				margin-left: 5px;
			}

			&.left {
				margin-right: 5px;
			}
		}

		&:hover {
			background-position: right center;
		}

		&.white {
			background: $_copy;
			color: $primary;
		}
	}
</style>


